module.exports = __webpack_public_path__ + "img/enhancing-safety.b2a3b0f8.svg";